namespace GeniuzPOS.Lookups {
    export interface CusImportOrLocalRow {
        CusImportOrLocal?: string;
        LookupName?: string;
    }

    export namespace CusImportOrLocalRow {
        export const idProperty = 'CusImportOrLocal';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'Lookups.CusImportOrLocal';
        export const lookupKey = 'Lookups.CusImportOrLocal';

        export function getLookup(): Q.Lookup<CusImportOrLocalRow> {
            return Q.getLookup<CusImportOrLocalRow>('Lookups.CusImportOrLocal');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CusImportOrLocal = "CusImportOrLocal",
            LookupName = "LookupName"
        }
    }
}
